<div class="paginator">
  <div class="page-size">
    <label class="size-label">Registros por página:</label>
    <ds-dropdown
      class="force-mobile"
      placeholder="Select option"
      [(ngModel)]="pageSize"
      [disabled]="disabled"
      (ngModelChange)="changePageSize($event)"
    >
      <ds-option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</ds-option>
    </ds-dropdown>
  </div>

  <div class="page-controls">
    <button
      *ngIf="showFirstLastButtons"
      class="control-button"
      (click)="setPage(0)"
      [disabled]="pageIndex === 0 || disabled"
      title="Primera página"
    >
      <span class="material-symbols-outlined icon">first_page</span>
    </button>

    <button
      class="control-button"
      (click)="setPage(pageIndex - 1)"
      [disabled]="pageIndex === 0 || disabled"
      title="Página anterior"
    >
      <span class="material-symbols-outlined icon">chevron_backward</span>
    </button>

    <ng-container *ngFor="let page of pagesToShow()">
      <button
        [class.selected]="page === pageIndex"
        class="page-button center-xy"
        (click)="setPage(page)"
        *ngIf="page !== -1"
        [disabled]="disabled"
      >
        <span class="page-button-text">{{ page + 1 }}</span>
      </button>
      <span *ngIf="page === -1" class="ellipsis" [class.disabled]="disabled">…</span>
    </ng-container>

    <button
      class="control-button"
      (click)="setPage(pageIndex + 1)"
      [disabled]="pageIndex >= totalPages - 1 || disabled"
      title="Página siguiente"
    >
      <span class="material-symbols-outlined icon">chevron_forward</span>
    </button>

    <button
      *ngIf="showFirstLastButtons"
      class="control-button"
      (click)="setPage(totalPages - 1)"
      [disabled]="pageIndex >= totalPages - 1 || disabled"
      title="Última página"
    >
      <span class="material-symbols-outlined icon">last_page</span>
    </button>
  </div>
</div>
